let aos = require("aos");

aos.init({
	once: true,
});

jQuery(document).ready(function ($) {
	$(".zip-code-form").validate();

	// Match Height Values
	$(".dark-section-box").matchHeight();
	$(".icon-box").matchHeight();
	$(
		".branch-contact-content-left, .vertical-divider, .branch-contact-content-right"
	).matchHeight();
	$(".affiliate-product-description").matchHeight();

	$(".mh").matchHeight();
	// Yoast Accordion
	let yoast = {
		accordion: function () {
			$(".wp-block-yoast-faq-block")
				.find(".schema-faq-question")
				.click(function () {
					//Expand or collapse this panel
					$(this)
						.nextAll(".schema-faq-answer")
						.eq(0)
						.slideToggle("fast", function () {
							if ($(this).hasClass("collapse")) {
								$(this).removeClass("collapse");
							} else {
								$(this).addClass("collapse");
							}
						});

					//Hide the other panels
					$(".schema-faq-answer")
						.not($(this).nextAll(".schema-faq-answer").eq(0))
						.slideUp("fast");
				});

			$(".wp-block-yoast-faq-block .schema-faq-question").click(
				function () {
					$(".wp-block-yoast-faq-block .schema-faq-question")
						.not($(this))
						.removeClass("collapse");
					if ($(this).hasClass("collapse")) {
						$(this).removeClass("collapse");
					} else {
						$(this).addClass("collapse");
					}
				}
			);
		},
	};
	$(".schema-faq-section:first-child .schema-faq-answer").show();
	$(".schema-faq-section:first-child .schema-faq-question").addClass(
		"collapse"
	);
	yoast.accordion();

	// Smooth Scroll to Anchor
	document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
		anchor.addEventListener("click", function (e) {
			e.preventDefault();

			document.querySelector(this.getAttribute("href")).scrollIntoView({
				behavior: "smooth",
			});
		});
	});

	// Header Navigation Menu for Mobile
	$(".open-menu").click(function () {
		$(".mobile-menu").slideDown();
		$(this).hide();
		$(".close-menu").show();
		$("body").css("overflow", "hidden");
	});
	$(".close-menu").click(function () {
		$(".mobile-menu").slideUp();
		$(this).hide();
		$(".open-menu").show();
		$("body").css("overflow", "scroll");
	});

	// Desktop Drop down click instead of hover
	$(".header-navigation li.menu-item-has-children > a").append(
		' <span class="caret"><i class="fa fa-caret-down"></i></span>'
	);
	$("#menu-header-top-row-navigation li.menu-item-has-children > a").append(
		' <span class="caret"><i class="fa fa-caret-down"></i></span>'
	);
	$(
		"#menu-header-left-of-logo-navigation li.menu-item-has-children > a"
	).append(' <span class="caret"><i class="fa fa-caret-down"></i></span>');
	$(
		"#menu-header-right-of-logo-navigation li.menu-item-has-children > a"
	).append(' <span class="caret"><i class="fa fa-caret-down"></i></span>');

	$("#menu-header-navigation li.menu-item-has-children").click(function (e) {
		$(this).children(".sub-menu").slideToggle();
		$(this).siblings().children(".sub-menu").slideUp();
		$(this).toggleClass("clicked");
		$("#menu-header-top-row-navigation").find(".sub-menu").slideUp();
	});
	$(document).click(function (eventOne) {
		var $trigger = $("#menu-header-navigation li.menu-item-has-children");
		if (
			$trigger !== eventOne.target &&
			!$trigger.has(eventOne.target).length
		) {
			$(
				"#menu-header-navigation li.menu-item-has-children .sub-menu"
			).slideUp();
		}
	});
	$("#menu-header-top-row-navigation li.menu-item-has-children").click(
		function (eventTwo) {
			var $trigger = $(
				"#menu-header-navigation li.menu-item-has-children"
			);
			if (
				$trigger !== eventTwo.target &&
				!$trigger.has(eventTwo.target).length
			) {
				$(
					"#menu-header-navigation li.menu-item-has-children .sub-menu"
				).slideUp();
				$(this).find(".sub-menu").slideToggle();
			}
		}
	);

	$("#menu-header-left-of-logo-navigation li.menu-item-has-children").click(
		function (e) {
			$(this).children(".sub-menu").slideToggle();
			$(this).siblings().children(".sub-menu").slideUp();
			$(this).toggleClass("clicked");
			$("#menu-header-right-of-logo-navigation")
				.find(".sub-menu")
				.slideUp();
		}
	);
	$("#menu-header-right-of-logo-navigation li.menu-item-has-children").click(
		function (e) {
			$(this).children(".sub-menu").slideToggle();
			$(this).siblings().children(".sub-menu").slideUp();
			$(this).toggleClass("clicked");
			$("#menu-header-left-of-logo-navigation")
				.find(".sub-menu")
				.slideUp();
		}
	);
	$("#menu-header-left-of-logo-navigation li.menu-item-has-children").click(
		function (eventThree) {
			var $trigger = $(
				"#menu-header-left-of-logo-navigation li.menu-item-has-children"
			);
			if (
				$trigger !== eventThree.target &&
				!$trigger.has(eventThree.target).length
			) {
				$(
					"#menu-left-of-logo-navigation li.menu-item-has-children .sub-menu"
				).slideUp();
				$(this).find(".sub-menu").slideToggle();
			}
		}
	);

	$(document).on("click", function (event) {
		var $trigger = $("header li.menu-item-has-children");
		if ($trigger !== event.target && !$trigger.has(event.target).length) {
			$(".sub-menu").slideUp();
		}
	});

	// Mobile Walker Menu
	$(".mobile-nav li.has-sub > a").on("click", function () {
		$(this).removeAttr("href");
		var element = $(this).parent("li");
		if (element.hasClass("open")) {
			element.removeClass("open");
			element.find("li").removeClass("open");
			element.find("ul").slideUp();
		} else {
			element.addClass("open");
			element.children("ul").slideDown();
			element.siblings("li").children("ul").slideUp();
			element.siblings("li").removeClass("open");
			element.siblings("li").find("li").removeClass("open");
			element.siblings("li").find("ul").slideUp();
		}
	});

	$("ul.checklist li, .checklist li").prepend(
		'<i class="fa fa-check-circle" aria-hidden="true"></i>'
	);
	$(".schema-faq-question").prepend(
		'<i class="fa fa-times-circle absolute left-0 accordion-mark" aria-hidden="true"></i>'
	);

	jQuery(".image-slider").slick({
		prevArrow: jQuery(".image-slider-prev"),
		nextArrow: jQuery(".image-slider-next"),
		infinite: true,
		arrows: true,
		dots: false,
		adaptiveHeight: true,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 10000,
		cssEase: "ease-in-out",
	});
});
